"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KIND_MAP = exports.CLASSNAME_ANIMATION = void 0;
var _js = _interopRequireDefault(require("@quintoandar/cozy-theme/tokens/js"));
var _Info = _interopRequireDefault(require("@quintoandar/cozy-icons/Info"));
var _Warning = _interopRequireDefault(require("@quintoandar/cozy-icons/Warning"));
var _CheckCircle = _interopRequireDefault(require("@quintoandar/cozy-icons/CheckCircle"));
var _Error = _interopRequireDefault(require("@quintoandar/cozy-icons/Error"));
var _Chat = _interopRequireDefault(require("@quintoandar/cozy-icons/Chat"));
var _Alert = require("./Alert.types");
var _messages = _interopRequireDefault(require("./messages"));
var _KIND_MAP;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var KIND_MAP = exports.KIND_MAP = (_KIND_MAP = {}, _defineProperty(_KIND_MAP, _Alert.Kind.CRITICAL, {
  a11yProps: {
    'aria-atomic': 'true',
    'aria-live': 'assertive'
  },
  icon: {
    component: _Error["default"],
    htmlColor: _js["default"].alias.color.icon["default"],
    iconTitle: _messages["default"].criticalIconTitle
  }
}), _defineProperty(_KIND_MAP, _Alert.Kind.DEFAULT, {
  a11yProps: {
    'aria-atomic': 'false',
    'aria-live': 'off'
  },
  icon: {
    component: _Info["default"],
    htmlColor: _js["default"].alias.color.icon.brand["default"],
    iconTitle: _messages["default"].defaultIconTitle
  }
}), _defineProperty(_KIND_MAP, _Alert.Kind.POSITIVE, {
  a11yProps: {
    'aria-atomic': 'false',
    'aria-live': 'off'
  },
  icon: {
    component: _CheckCircle["default"],
    htmlColor: _js["default"].alias.color.icon["default"],
    iconTitle: _messages["default"].positiveIconTitle
  }
}), _defineProperty(_KIND_MAP, _Alert.Kind.WARNING, {
  a11yProps: {
    'aria-atomic': 'true',
    'aria-live': 'polite'
  },
  icon: {
    component: _Warning["default"],
    htmlColor: _js["default"].alias.color.icon["default"],
    iconTitle: _messages["default"].warningIconTitle
  }
}), _defineProperty(_KIND_MAP, _Alert.Kind.INFORMATION, {
  a11yProps: {
    'aria-atomic': 'false',
    'aria-live': 'off'
  },
  icon: {
    component: _Chat["default"],
    htmlColor: _js["default"].alias.color.icon["default"],
    iconTitle: _messages["default"].informationIconTitle
  }
}), _KIND_MAP);
var CLASSNAME_ANIMATION = exports.CLASSNAME_ANIMATION = 'Cozy-AlertAnimation';